export const info = {
	firstname: {
		title: '',
		desc: '',
	},
};
